// Build-time switch for development-only tooling.
//
// REACT_APP_DEBUG wins when it is set to "true" or "false"; otherwise debug
// tooling follows the build, on under `npm start` and off under `npm run build`.
// So a deploy has it off unless the hosting environment asks for it, and a
// local `.env.local` with REACT_APP_DEBUG=false turns it off while developing.
//
// Create React App inlines both variables as string literals at build time, so
// a production build folds this to `false` and the minifier drops every guarded
// branch out of the bundle.
const debugFlag = process.env.REACT_APP_DEBUG

export const isDebugEnabled =
    debugFlag === "true" ? true :
    debugFlag === "false" ? false :
    process.env.NODE_ENV === "development"
